import React from "react";
import PropTypes from "prop-types";

const IncompleteCircle = (props) => {
  const { color, width, height, ...other } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <g id="bg" fill="#fff" stroke={color} strokeWidth="2">
        <circle cx="10" cy="10" r="10" stroke="none" />
        <circle cx="10" cy="10" r="9" fill="none" />
      </g>
    </svg>
  );
};

IncompleteCircle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

IncompleteCircle.defaultProps = {
  color: "#000000",
  width: 24,
  height: 24,
};

export default IncompleteCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/IncompleteCircle.jsx